import { useTheme } from '@sixfold/common-ui';
import { getBounds, getBoundsCenter } from '@sixfold/geo-primitives';
import React from 'react';

import { VehiclesOverlay } from './vehicles_overlay';
import { getEmbedConfig } from '../../lib/data';
import { openSatelliteViewUrl } from '../../lib/util/url';
import { MapGL } from '../../map/components/map_gl';
import { MapViewport } from '../../map/components/map_viewport';
import { getThemedMapStyle } from '../../tour/entities';
import { Vehicle, VehicleHistory, VehicleBreakHistory, VehicleStatus } from '../entities';
import { vehiclesWithLocation } from '../utils';

interface MapVehicle extends Vehicle {
  history?: VehicleHistory[];
  breakHistory?: VehicleBreakHistory[];
  ghost?: VehicleHistory;
  status: VehicleStatus | null;
}

export interface VehiclesMapProps {
  data: {
    vehicles: MapVehicle[];
  };
}

const DefaultCenter = { lat: 50.9854724, lng: 10.8749089 };

export const VehiclesMap: React.FC<VehiclesMapProps> = (props) => {
  const {
    data: { vehicles },
  } = props;
  const { currentTheme } = useTheme();
  const locations = vehiclesWithLocation(vehicles).map(({ status: { latitude, longitude } }) => ({
    lat: latitude,
    lng: longitude,
  }));
  const { lat: latitude, lng: longitude } =
    locations.length > 0 ? getBoundsCenter(getBounds(locations)) : DefaultCenter;
  const zoom = locations.length > 1 ? 1 : 5;
  const defaultViewport = { longitude, latitude, zoom, maxZoom: 20, pitch: 0, bearing: 0, width: 0, height: 0 };
  const config = getEmbedConfig();

  if (config === null) {
    throw Error('Missing config');
  }

  return (
    <MapViewport
      style={{ backgroundColor: 'rgba(0,0,0,0.1)', minHeight: 'calc(100vh - 100px)' }}
      defaultViewport={defaultViewport}>
      {({ width, height, viewport, onViewportChange }) => (
        <MapGL
          {...{ ...viewport, width, height }}
          mapStyle={getThemedMapStyle(currentTheme)}
          mapboxApiAccessToken={config.mapbox_token}>
          <VehiclesOverlay
            viewport={{ ...viewport, width, height }}
            onViewportChange={onViewportChange}
            vehicles={vehicles}
            onLayerClick={openSatelliteViewUrl}
          />
        </MapGL>
      )}
    </MapViewport>
  );
};
